
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initPerformanceOptimizations } from './utils/performanceOptimization';

// Initialize performance optimizations
initPerformanceOptimizations();

// Remove Lovable badge
const removeLovableBadge = () => {
  const observer = new MutationObserver(() => {
    const badge = document.querySelector('[data-lovable-badge]');
    if (badge) {
      badge.remove();
    }
    
    // Also check for any elements with lovable in class names
    const lovableElements = document.querySelectorAll('[class*="lovable"]');
    lovableElements.forEach(el => {
      if (el.textContent?.includes('Edit in Lovable') || el.textContent?.includes('Lovable')) {
        el.remove();
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Initial cleanup
  setTimeout(() => {
    const badge = document.querySelector('[data-lovable-badge]');
    if (badge) badge.remove();
  }, 100);
};

// Apply badge removal after DOM is ready
document.addEventListener('DOMContentLoaded', removeLovableBadge);
// Also apply immediately in case DOM is already ready
removeLovableBadge();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
